import moment from 'moment-timezone'
/**
 * Allowed timezone values – subset of the list here
 * https://stackoverflow.com/a/54500197
 */
export type AllowedTimezones = string

export const currentTimezone: AllowedTimezones = moment.tz.guess() as AllowedTimezones
